module.exports = __webpack_public_path__ + "img/Avatar-42.032b42bf.svg";